/**
Project: Voice Panel (c)
Title: Filter Users 
Description: Component to dispay the user filter page.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import ResponseUtil from "../../../../core/helpers/response-util";
import PageLoader from "../../common/helpers/page-loader";
import {
  Flex,
  Text,
  RadioGroupItem,
  FormLabel,
  Input,
  Button,
  Dropdown,
  RadioGroup,
  Ref,
  // ExclamationCircleIcon,
  // Tooltip,
  // Divider
} from "@fluentui/react-northstar";
import { AppPageTitle } from "../../../../core/components/app-page-title";
import { manageError } from "../../../../core/actions/common-actions";
import { Grid, Row, Col } from "react-flexbox-grid";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import AlertInfoMessage from "../../common/helpers/alert-info-message";
import { AppConfigProps } from "../../../../core/settings/app-config";
import { VoiceAdminURLProps } from "../../common/settings/voice-admin-urls";
import UsersStatus from "../components/user-status";
import {
  getUsersRoutingPolicies,
  getTenentUsersBulk,
} from "../actions/user-actions";
import moment from "moment";
import _, { orderBy } from "lodash";
import { getCountryList } from "../../common/actions/general-actions";

class userSearch extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_common = "vpa_common";
  _intl_ns_vpa_users = "vpa_users";

  constructor(props) {
    super(props);
    this.state = {
      searchCriteria: this.searchCriteria(),
      usersBulkStatus: VoiceAdminConstants.USERS.BULK_STATUS,
      filterPageSize: VoiceAdminConstants.USERS.PAGE_SIZE,
      usersPropagation: null,
      isPageDataFetched: false,
      isFormDataFilled: false,
      isFormDataErrorStatus: false,
      errorMessage: null,
      numberAssignmentStatusList: VoiceAdminConstants.USERS.PHONE_ASSIGN_STATUS,
    };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    await this.loadPageData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  loadPageData = async () => {
    await this.setStateAsync({ isPageDataFetched: false });
    await this.getUsersRoutingPolicies();
    await this.fetchTenentUsersBulkStatus();
    await this.setStateAsync({ isPageDataFetched: true });
  };

  getUsersRoutingPolicies = async () => {
    try {
      await this.props.getUsersRoutingPolicies();
    } catch (err) {
      await manageError(err, this.props.history);
    }
  };

  fetchTenentUsersBulkStatus = async () => {
    await getTenentUsersBulk(this.state.usersBulkStatus, this._cancelToken)
      .then(async (res) => {
        if (
          res &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res.data.result
        ) {
          const propagation = res.data.result;
          await this.setStateAsync({ usersPropagation: propagation });
          if (
            propagation.overallStatus !==
            VoiceAdminConstants.USN_DATA_PROPAGATION.OVERALL_STATUS_COMPLETED
          ) {
            await this.setStateAsync({ isAlterDataPropagated: false });
          } else {
            await this.setStateAsync({ isAlterDataPropagated: true });
          }
        }
      })
      .catch(async (err) => {
        await this.setStateAsync({ isPageDataFetched: true });
        const errorStatus = ResponseUtil.getStatus(err);
        if (
          errorStatus &&
          errorStatus === AppConfigProps.httpStatusCode.badRequest
        ) {
          const primeError = ResponseUtil.getPrimeError(err);
          if (
            primeError &&
            primeError.code ===
              VoiceAdminConstants.SERVER_ERROR_CODE.VOICE_SETUP_NOTCOMPLETED
          ) {
            this.props.history.push(VoiceAdminURLProps.setup);
            return;
          }
        } else {
          await manageError(err, this.props.history);
        }
      });
  };

  searchCriteria = () => {
    return {
      name: "",
      email: "",
      phone: "",
      policyId: "",
      numberAssignmentStatus: "",
      usageLocation:"",
      filterType: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
    };
  };

  setAddFormFieldValue = async (fieldName, fieldValue) => {
    if (fieldName && this.state.searchCriteria) {
      await this.setStateAsync({
        searchCriteria: {
          ...this.state.searchCriteria,
          [fieldName]: fieldValue,
        },
      });
      await this.checkformFieldData();
      await this.clearAlert();
    }
    await this.validateSearchFormField();
  };

  getListOfPolicy = (policys) => {
    let sortedPolicies = [];

    if (policys && policys.length > 0) {
      policys = [""].concat(policys);
      sortedPolicies = _.orderBy(
        policys,
        (policy) => policy.toLowerCase(),
        "asc"
      );
    }

    return sortedPolicies;
  };

  checkformFieldData = async () => {
    if (
      this.state.searchCriteria &&
      (this.state.searchCriteria.email.trim() ||
        this.state.searchCriteria.phone.trim() ||
        this.state.searchCriteria.name.trim() ||
        this.state.searchCriteria.policyId.trim() ||
        this.state.searchCriteria.usageLocation.trim() ||
        this.state.searchCriteria.numberAssignmentStatus.trim())
    ) {
      await this.setStateAsync({ isFormDataFilled: true });
    } else {
      await this.setStateAsync({ isFormDataFilled: false });
    }
  };

  clearAlert = async () => {
    await this.setStateAsync({
      errorMessage: null,
      isFormDataErrorStatus: false,
    });
  };

  validateSearchFormField = async () => {
    let isSearchFormValid = true;
    const regExp = /^[0-9/b]+$/g; // Regex validate Pnone Number
    if (
      this.state.searchCriteria &&
      this.state.searchCriteria.phone.trim() !== ""
    ) {
      if (regExp.test(this.state.searchCriteria.phone) === false) {
        isSearchFormValid = false;
        await this.setStateAsync({
          isFormDataErrorStatus: true,
          errorMessage: IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.error.phoneNumberOnly"
          ),
        });
      } else if (this.state.searchCriteria.phone.startsWith("0") === true) {
        isSearchFormValid = false;
        await this.setStateAsync({
          isFormDataErrorStatus: true,
          errorMessage: IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.error.phoneNumberZero"
          ),
        });
      } else if (
        parseInt(this.state.searchCriteria.phone.length) <= parseInt(1)
      ) {
        isSearchFormValid = false;
        await this.setStateAsync({
          isFormDataErrorStatus: true,
          errorMessage: IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.error.phoneNumberTwoDigits"
          ),
        });
      }
    }

    return isSearchFormValid;
  };

  handleSearch = async () => {
    let isSearchFormValid = await this.validateSearchFormField();
    if (isSearchFormValid === true) {
      this.props.history.push({
        pathname: VoiceAdminURLProps.usersList,
        state: {
          name: this.state.searchCriteria.name.trim()
            ? this.state.searchCriteria.name.trim()
            : "",
          email: this.state.searchCriteria.email.trim()
            ? this.state.searchCriteria.email.trim()
            : "",
          phone: this.state.searchCriteria.phone.trim()
            ? this.state.searchCriteria.phone.trim()
            : "",
          policyId: this.state.searchCriteria.policyId.trim()
            ? this.state.searchCriteria.policyId.trim()
            : "",
          filterType: this.state.searchCriteria.filterType.trim()
            ? this.state.searchCriteria.filterType.trim()
            : "",
          pageSize: this.state.filterPageSize.trim()
            ? this.state.filterPageSize.trim()
            : "",
          usageLocation: this.state.searchCriteria.usageLocation.trim()
            ? this.state.searchCriteria.usageLocation.trim()
            : "",
          numberAssignmentStatus: this.state.searchCriteria.numberAssignmentStatus?.trim()
            ? this.state.searchCriteria.numberAssignmentStatus?.trim()
            : "",
        },
      });
    }
  };

  openUsersStatusDialog = async () => {
    await this.setStateAsync({ showUsersStatusDialog: true });
  };

  refreshUserPropagationBulk = async (usersPropagation) => {
    await this.getUsersPropagationInfoText(usersPropagation);
    if (
      usersPropagation &&
      usersPropagation.overallStatus !==
        VoiceAdminConstants.USN_DATA_PROPAGATION.OVERALL_STATUS_COMPLETED
    ) {
      await this.setStateAsync({ isAlterDataPropagated: false });
    } else {
      await this.setStateAsync({
        isAlterDataPropagated: true,
        usersPropagation: usersPropagation,
      });
    }
  };

  renderUsersStatusDialog = () => {
    return (
      <UsersStatus
        showDialogBox={this.state.showUsersStatusDialog}
        history={this.props.history}
        functionSeettings={"filterView"}
        refreshUserPropagationBulk={this.refreshUserPropagationBulk}
        setUsersUpdateData={null}
        hideDialogBox={async () => {
          await this.setState({ showUsersStatusDialog: false });
        }}
      />
    );
  };

  getUsersPropagationInfoText = (propagation) => {
    if (propagation) {
      let propagationTimestamp = propagation.createTimestamp;
      if (
        propagation.endTimestamp &&
        propagation.endTimestamp !== "0001-01-01T00:00:00"
      ) {
        propagationTimestamp = propagation.endTimestamp;
      }
      const timestampObj = moment(propagationTimestamp);
      const dateString = timestampObj.format("ll");
      const timeString = timestampObj.format("LTS");

      let text = IntlUtil.getText(
        this._intl_ns_vpa_users,
        "notification.info.usersDataPropagationCompleted"
      );
      if (timestampObj && dateString && timeString) {
        text =
          text +
          " " +
          IntlUtil.getSubstituteText(
            this._intl_ns_vpa_users,
            "notification.info.usersDataPropagationDateTime",
            [
              {
                key: "<DATE>",
                value: dateString,
              },
              {
                key: "<TIME>",
                value: timeString,
              },
            ]
          );
      }
      return text;
    } else return "";
  };

  setCountryList = (key) => {
    let country = null;
    if (this.props.countryStatesData?.length > 0) {
      this.props.countryStatesData.find((country) => key?.toLowerCase()===country?.countryCode?.toLowerCase());
    }
    return country?.countryName;
  };

  handleCountryChange=async(e,option)=>{
    if(this.props.countryStatesData?.length>0){
      let country=null;
      country=this.props.countryStatesData.find(con=>con.countryName?.toLowerCase().trim()===option.value?.toLowerCase())
      await this.setAddFormFieldValue("usageLocation",country?.countryCode??"")

    }
  }
  render() {
    return (
      <>
        <AppPageTitle
          pageTitle={IntlUtil.getText(
            this._intl_ns_vpa_users,
            "title.usersfilter"
          )}
        />
        <Flex column className="page-wrapper">
          <Flex column className="page-title-wrapper">
            <Text className="page-title-text">
              {IntlUtil.getText(this._intl_ns_vpa_users, "content.users")}
            </Text>
          </Flex>
          <PageLoader
            status={this.state.isPageDataFetched}
            size="medium"
            labelPosition="below"
            label={IntlUtil.getText(
              this._intl_ns_common,
              "content.loadingInprogress"
            )}
            type="full-center"
          >
            <Grid fluid className="p-l-0 m-l-20">
              <Row className="vpa-usn-row">
                <Col
                  xl={6}
                  lg={6}
                  md={12}
                  sm={12}
                  xs={12}
                  className="m-t-10 vpa-usn-col"
                >
                  <div className="vpa-usn-text m-b-15">
                    <Text className="text-semibold">
                      {IntlUtil.getText(
                        this._intl_ns_vpa_users,
                        "content.searchUsers"
                      )}
                    </Text>
                  </div>
                  <Row>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12} className="p-l-5">
                      <RadioGroupItem
                        name="filterType"
                        id="filterType"
                        label={IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.anyOneConditions"
                        )}
                        value={
                          VoiceAdminConstants.USERS.FILTER_CONDITIONS
                            .ANY_CONDITIONS
                        }
                        checked={
                          this.state.searchCriteria.filterType ===
                          VoiceAdminConstants.USERS.FILTER_CONDITIONS
                            .ANY_CONDITIONS
                        }
                        className="vpa-inv-radio m-l-0 p-l-0"
                        onClick={(e, select) =>
                          this.setAddFormFieldValue("filterType", select.value)
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                      <RadioGroupItem
                        name="filterType"
                        id="filterType"
                        label={IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.allConditions"
                        )}
                        value={
                          VoiceAdminConstants.USERS.FILTER_CONDITIONS
                            .ALL_CONDITIONS
                        }
                        checked={
                          this.state.searchCriteria.filterType ===
                          VoiceAdminConstants.USERS.FILTER_CONDITIONS
                            .ALL_CONDITIONS
                        }
                        className="vpa-inv-radio m-l-0 p-l-0"
                        onClick={(e, select) =>
                          this.setAddFormFieldValue("filterType", select.value)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="m-t-10 p-l-5"
                    >
                      <FormLabel className="m-b-10 page-text text-semibold text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.displayName"
                        )}
                      </FormLabel>
                      <Input
                        maxLength="100"
                        type="text"
                        inverted
                        className="vpa-inventory-input"
                        id="name"
                        name="name"
                        value={this.state.searchCriteria.name}
                        onChange={(e) => {
                          this.setAddFormFieldValue(
                            e.target.name,
                            e.target.value
                          );
                        }}
                      />
                    </Col>
                    <Col
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="m-t-10"
                    >
                      <FormLabel className="m-b-10 page-text text-semibold text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.phoneNumber"
                        )}
                      </FormLabel>
                      <Input
                        maxLength="100"
                        type="text"
                        inverted
                        className="vpa-inventory-input"
                        id="phone"
                        name="phone"
                        value={this.state.searchCriteria.phone}
                        onChange={(e) => {
                          this.setAddFormFieldValue(
                            e.target.name,
                            e.target.value
                          );
                        }}
                      />
                      <Text className="text-fc-red text-fs-s m-t-0 m-b-0">
                        {this.state.isFormDataErrorStatus === true
                          ? this.state.errorMessage
                          : null}
                      </Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="m-t-20 p-l-5"
                    >
                      <FormLabel className="m-b-10 page-text text-semibold text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.userName"
                        )}
                      </FormLabel>
                      <Input
                        maxLength="100"
                        type="text"
                        inverted
                        className="vpa-inventory-input"
                        id="email"
                        name="email"
                        value={this.state.searchCriteria.email}
                        onChange={(e) => {
                          this.setAddFormFieldValue(
                            e.target.name,
                            e.target.value
                          );
                        }}
                      />
                    </Col>
                    <Col
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="m-t-20"
                    >
                      <FormLabel className="m-b-10 page-text text-semibold text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.callingPolicy"
                        )}
                      </FormLabel>
                      <Dropdown
                        inverted
                        className="vpa-dropdown"
                        id="policyId"
                        name="policyId"
                        items={
                          this.getListOfPolicy(
                            this.props.usersRoutingPolicies
                          ) || []
                        }
                        placeholder={IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.selectPolicy"
                        )}
                        highlightFirstItemOnOpen={true}
                        value={this.state.searchCriteria.policyId}
                        onBlur={this.handleSearchFormFieldBlur}
                        renderItem={(Item, props) => {
                          if (props.key === "") {
                            return <Item {...props} header={"None"} />;
                          } else {
                            return <Item {...props} header={props.header} />;
                          }
                        }}
                        onChange={(e, select) => {
                          this.setAddFormFieldValue("policyId", select?.value??"");
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="m-t-20 p-l-5"
                    >
                      <FormLabel className="m-b-10 page-text text-semibold text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.country"
                        )}
                      </FormLabel>
                      <Dropdown
                        inverted
                        className="vpa-dropdown"
                        id="usageLocation"
                        name="usageLocation"
                        items={getCountryList(this.props.countryStatesData)}
                        placeholder={IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.selectCountry"
                        )}
                        selected
                        highlightFirstItemOnOpen={true}
                        value={this.setCountryList(this.state.searchCriteria.usageLocation)}
                        searchInput={{
                          input: {
                            children: (DropdownSearchInput, props) => (
                              <Ref innerRef={this.countryRef}>
                                <DropdownSearchInput {...props} />
                              </Ref>
                            ),
                          },
                        }}
                         search={(filteredItemsByValue, searchQuery) => {
                                            const result = filteredItemsByValue.filter(
                                              (item) =>
                                                item?.toLowerCase() &&
                                                _.startsWith(
                                                  item.toLowerCase(),
                                                  searchQuery.toLowerCase()
                                                )
                                            );
                                            if (result.length === 0) {
                                              return [];
                                            }
                                            return result;
                                          }}
                        onChange={async(e, select) => {
                          await this.handleCountryChange(e,select)
                        }}
                      />
                    </Col>
                    <Col
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="m-t-20"
                    >
                      <FormLabel className="m-b-10 page-text text-semibold text-fc-dark">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_users,
                          "content.phoneNumberAssignmentStatus"
                        )}
                      </FormLabel>
                      <RadioGroup
                        id="numberAssignmentStatus"
                        name="numberAssignmentStatus"
                        checkedValue={
                          this.state.searchCriteria.numberAssignmentStatus
                        }
                        items={this.state.numberAssignmentStatusList || []}
                        onCheckedValueChange={(e, props) =>
                          this.setAddFormFieldValue(
                            "numberAssignmentStatus",
                            props.value
                          )
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xl={7}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="m-t-20"
                    >
                      <Flex column gap="gap.large">
                        <Button
                          onClick={this.handleSearch}
                          disabled={!this.state.isFormDataFilled}
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_common,
                            "content.search"
                          )}
                          primary
                          className="vpa-usn-button m-b-0"
                        />
                      </Flex>
                    </Col>
                  </Row>
                </Col>
                <Col xl={5} lg={5} md={12} sm={12} xs={12} className="m-t-10">
                  <div className="vpa-usn-text m-b-15">
                    <Text className="text-semibold">
                      {IntlUtil.getText(
                        this._intl_ns_vpa_users,
                        "content.usersList"
                      )}
                    </Text>
                  </div>
                  <Row>
                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="m-t-10"
                    >
                      <Flex column gap="gap.large">
                        <Text className="page-text m-b-10">
                          {IntlUtil.getText(
                            this._intl_ns_vpa_users,
                            "content.viewUsersWithoutFilter"
                          )}
                        </Text>
                      </Flex>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="m-t-30"
                    >
                      <Flex column gap="gap.large">
                        <Button
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_users,
                            "content.userview"
                          )}
                          primary
                          onClick={() =>
                            this.props.history.push(
                              VoiceAdminURLProps.usersList
                            )
                          }
                          className="vpa-usn-button m-b-0"
                        />
                      </Flex>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                {this.state.usersPropagation ? (
                  <>
                    {this.state.isAlterDataPropagated === false ? (
                      <Col xs={12} lg={12} md={12} className="m-m-t-10 m-t-20">
                        <AlertInfoMessage
                          fitted={true}
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_users,
                            "notification.info.usersDataPropagationInprogress"
                          )}
                          linkDetails={{
                            label: IntlUtil.getText(
                              this._intl_ns_vpa_users,
                              "content.viewStatus"
                            ),
                            callback: this.openUsersStatusDialog,
                          }}
                        />
                      </Col>
                    ) : (
                      <Col xs={12} lg={12} md={12} className="m-m-t-10 m-t-20">
                        <AlertInfoMessage
                          fitted={true}
                          content={this.getUsersPropagationInfoText(
                            this.state.usersPropagation
                          )}
                          linkDetails={{
                            label: IntlUtil.getText(
                              this._intl_ns_vpa_users,
                              "content.viewResult"
                            ),
                            callback: this.openUsersStatusDialog,
                          }}
                        />
                      </Col>
                    )}
                  </>
                ) : null}
              </Row>
            </Grid>
            {this.renderUsersStatusDialog()}
          </PageLoader>
        </Flex>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  usersRoutingPolicies: state.userStore.usersRoutingPolicies,
  countryStatesData: state.generalStore.countryStatesData,
});

const mapActionToProps = {
  getUsersRoutingPolicies,
};

export default connect(mapStateToProps, mapActionToProps)(userSearch);
